// Constantes de configuration du puits et du verrouillage.
// Module pur (sans état) — premier pas de l'éclatement progressif de main.ts.
export const GRID = 7;
export const HEIGHT = 14;
// Lignes/grilles à effacer pour gagner une Profondeur (un « niveau »). Pilote la cadence de
// gravité (core/difficulty.gravityMs) ET, en cascade, l'offre de reliques (tous les 2 niveaux),
// le changement de Monde (tous les 5) et l'intensité musicale. Abaissé 25 → 20 avec le passage
// à la courbe de chute géométrique : on atteint un peu plus tôt la partie « vivante » de la
// courbe sans bousculer ces cadences couplées. main.ts (HUD + debug) s'y réfère via cette constante.
export const LINES_PER_LEVEL = 20;
export const ZONE_MS = 15000;
// Budget TOTAL de prolongation d'UNE Zone, au-dessus de sa durée de base (zoneDurationMs). Chaque
// effacement pendant la Zone la prolonge, mais les bornes existantes étaient relatives à « MAINTENANT »
// (now+24 s / now+30 s) → en effaçant sans cesse on repoussait la fin indéfiniment = ZONE PERMANENTE
// (retour Directeur 2026-06 : « perma zone »). On fixe désormais un PLAFOND ABSOLU depuis l'activation
// (`zoneHardEnd = fin de base + ce budget`) : la Zone récompense un bon enchaînement puis se termine,
// quoi qu'il arrive. Le SIM anti-triche rejoue l'évènement ZONE_END enregistré → parité préservée.
export const ZONE_EXT_BUDGET_MS = 6000;
// ---- ANTI-TRICHE (couche de PLAUSIBILITÉ, core/verify — PAS le moteur) ----
// Plafond de lignes-équivalent (rangées + étages×GRID) BANQUÉES dans UNE SEULE Zone qu'un journal
// soumis peut prétendre. Le plafond « perma-zone » (ZONE_EXT_BUDGET_MS) n'est tenu que par l'HORLOGE
// du moteur vif ; le sim, pur relecteur, fait confiance au ZONE_END enregistré → un journal FORGÉ
// peut banquer sans borne dans une Zone éternelle (bonus ∝ banque^1.55 = jackpot superlinéaire).
// Les horodatages du journal sont DÉCLARÉS par le client (et incluent les pauses : gameStart n'est
// pas décalé à la pause) → toute borne TEMPORELLE serait à la fois forgeable et fausse-positive ;
// on borne donc la QUANTITÉ, insensible au temps. DÉRIVATION (généreuse, ≥3× l'extrême humain) :
// Zone active max = zoneDurationMs plafonnée (ZONE_MS + 3 s, cf. core/zone) + ZONE_EXT_BUDGET_MS
// = 24 s ; débit surhumain soutenu ~2,5 lignes/s → 60 ; + UNE cascade préparée maximale (puits
// entier en étages : HEIGHT × GRID = 98 lignes-équivalent) → extrême légitime ~160 ; ×3 → ~480,
// arrondi 500. AUCUN effet sur le moteur (vif ou sim) : core/verify REJETTE le score, il ne
// clampe jamais (un clamp côté sim seul désynchroniserait le rejeu bit-exact des runs honnêtes).
// À REVOIR si ZONE_MS / ZONE_EXT_BUDGET_MS / zoneDurationMs changent.
export const VERIFY_ZONE_BANK_MAX_LINES = 500;
export const LOCK_DELAY = 520;
export const MAX_RESETS = 15;
// Plafond du multiplicateur « prochain clear » cumulé par les reliques (Avalanche, Onde de
// choc, Prophétie, Noyau…) appliqué à UN clear : empêche l'empilement MULTIPLICATIF
// (×2 · ×1.8 · …) d'exploser le score en un seul tour. Une relique seule garde sa valeur
// (toutes ≤ ce plafond) ; seul le cumul est borné. main.ts l'applique à la résolution.
export const NEXT_MULT_CAP = 2.5;
// Charges de Bascule que les reliques peuvent rembourser AU TOTAL sur UN évènement de jeu
// (clear, bascule, combo…). Borne l'EMPILEMENT (plusieurs remboursements le même tour) qui
// rendait la Bascule infinie — la pile éternellement réparable. L'accumulation au fil des
// évènements reste possible.
// ABAISSÉ 2 → 1 : avec la banque de lignes (core/pressure.linesPerCharge) qui resserre déjà
// la recharge, on coupe aussi le robinet relique pour fermer définitivement le « tilt infini ».
// VÉRITÉ DES TEXTES : aucune relique ne doit annoncer plus que ce budget sur un évènement —
// les anciennes « +2 charges » (perfectionniste, onde_choc, mandala) sont réalignées sur 1
// (texte + addCharge), garde-fou dans tests/relics.test.ts.
export const RELIC_CHARGE_PER_EVENT = 1;

// Taille de la file « suivant » (aperçu des prochaines pièces). SOURCE UNIQUE partagée par main.ts
// (moteur vif) ET core/sim.ts (re-simulation anti-triche / rejeu bit-exact) : chaque pièce de la file
// consomme le flux RNG (drawPiece) — une file plus longue d'un côté TIRE PLUS TÔT dans le flux et
// décale TOUTE la séquence de pièces → chaque rejeu honnête divergerait → rejet EN MASSE de scores
// légitimes (functions/api/score.ts). Avant, cette valeur vivait en double (main.ts + sim.ts),
// synchronisée par commentaire seulement — une édition d'un seul côté suffisait à tout casser.
export const QUEUE_LEN = 5;

// Nombre d'entrées du catalogue de missions (MDEFS, main.ts). SOURCE UNIQUE de PARITÉ RNG : en mode
// méta, pickMissions mélange MDEFS par Fisher-Yates → consomme exactement MISSION_COUNT-1 tirages du
// flux de PIÈCES avant le premier remplissage de file. Le sim reproduit ces tirages « à blanc »
// (core/sim.makeInitial) sans porter le catalogue lui-même. Si MDEFS change de taille sans cette
// constante, la séquence de pièces diverge dès la première pièce → même rejet en masse que ci-dessus.
// main.ts DOIT garder MDEFS.length === MISSION_COUNT (à vérifier à chaque ajout de mission).
export const MISSION_COUNT = 6;

// Profondeur (« niveau ») atteinte pour un total de lignes effacées. SOURCE UNIQUE partagée par
// main.ts (moteur vif) ET core/sim.ts (re-simulation anti-triche / rejeu bit-exact). Toute dérive
// entre les deux casse la vérification : un score LÉGITIME au-delà de LINES_PER_LEVEL lignes
// re-simulerait à un autre niveau (donc autre gravité, autre cadence d'offre de reliques, autre sac
// de pièces via availablePieces, autre ×niveau de score) → divergence → score rejeté à tort
// (functions/api/score.ts). Pur & déterministe ; tolérant aux entrées non finies / négatives.
export function levelForLines(totalLines: number): number {
  const n = Number.isFinite(totalLines) ? Math.max(0, Math.floor(totalLines)) : 0;
  return 1 + Math.floor(n / LINES_PER_LEVEL);
}

// Plafond du nombre MAXIMUM de charges de Bascule (base 3, porté jusqu'à ce plafond par les reliques
// buffMaxCharge / mutateurs maxChargesAdd). SOURCE UNIQUE partagée par main.ts et core/sim.ts : un
// plafond divergent (le sim autorisait jusqu'à 8) laisserait la re-simulation exécuter une Bascule que
// le moteur vif aurait refusée (charges plafonnées) → divergence de rejeu. Cf. HUD « jusqu'à 6 ».
export const MAX_CHARGE_CAP = 6;

// Plafond du MULTIPLICATEUR DE SCORE DE RUN cumulé (buffScore des reliques + scoreMult du mutateur du
// jour). Même philosophie que NEXT_MULT_CAP, mais pour le multiplicateur PERMANENT de la run : une
// relique seule garde 100 % de sa valeur (la plus forte, Antimatière, vaut ×2.6 < ce plafond) ; ce qui
// est borné, c'est l'EMPILEMENT MULTIPLICATIF (×2.6 · ×2.0 · ×1.8 · …) qui faisait exploser le score.
// La baseline mesurée (docs/balance-baseline.md) a montré que le DECK de reliques — pas le Zone-stall —
// est le moteur de la dominance (×2.1 à placement égal) → on borne l'empilement pour pousser à
// diversifier les archétypes, sans dévaluer aucune relique isolée. SOURCE UNIQUE partagée main.ts ↔
// core/sim.ts (fidélité bit-exact de l'anti-triche). RÉVERSIBLE : ajuster cette seule valeur.
export const RUN_SCORE_MULT_CAP = 3.5;

// Plafond du COMPTEUR CUMULÉ « Nᵉ feat de la partie » des crochets de reliques croissants
// (Méridien +220×Nᵉ Croix, Palimpseste +500×Nᵉ TESSERAX). Ces compteurs montent sur TOUTE la run sans
// borne → un jeu superhumain/TAS (mesuré : ~189 Croix/run, cf. docs/balance-baseline.md) produit des
// scores à 8 chiffres qui passeraient l'anti-triche (jeu légitime) et trusteraient le classement. On
// plafonne N à une valeur GÉNÉREUSE — bien AU-DESSUS de toute cadence humaine (~30 feats/run) → aucun
// effet sur un vrai joueur, seul l'abus est borné. SOURCE UNIQUE (relics.ts lue par main.ts ET sim.ts)
// → fidélité anti-triche par construction. Réversible : ajuster cette seule valeur. (Même esprit que
// NEXT_MULT_CAP / RUN_SCORE_MULT_CAP : une relique garde sa valeur, seul l'empilement extrême est borné.)
export const CUMULATIVE_N_CAP = 50;

// Compose un buff de score dans le multiplicateur de run — désormais en ADDITIF de bonus :
// `current + (factor − 1)`, borné par RUN_SCORE_MULT_CAP. Restructure de l'économie des reliques
// (suite de BAL-DOMINANT-001) : le cumul MULTIPLICATIF (×2.6 · ×2.0 · ×1.8 → 9.36) était le moteur
// structurel de la dominance de deck — les plafonds ne faisaient que le CONTENIR après coup. En
// additif, chaque relique apporte son BONUS nominal (+25 % = +0.25) : une relique SEULE garde
// exactement sa valeur (1 + (f−1) = f, verrouillé par les tests), les textes joueur (« +25 % à
// tous les points ») deviennent LITTÉRALEMENT exacts, et l'empilement croît linéairement au lieu
// d'exponentiellement — le plafond redevient un garde-fou rare au lieu d'une borne systématique.
// Un malus (f<1) se soustrait ; plancher 0.1 par sûreté. Pure & tolérante (entrées non finies /
// ≤0 → neutralisées) ; appelée à CHAQUE buffScore, au mutateur du jour et au NG+, dans le moteur
// vif ET le sim → cumul identique des deux côtés (SOURCE UNIQUE, parité anti-triche).
export function cappedScoreMult(current: number, factor: number): number {
  const c = Number.isFinite(current) && current > 0 ? current : 1;
  const f = Number.isFinite(factor) && factor > 0 ? factor : 1;
  return Math.min(RUN_SCORE_MULT_CAP, Math.max(0.1, c + (f - 1)));
}

// Même loi ADDITIVE pour le multiplicateur « prochain clear » (Avalanche, Onde de choc, Prophétie,
// Noyau… cumulés sur UN même tour), bornée par NEXT_MULT_CAP. SOURCE UNIQUE vif↔sim — remplace le
// `nextClearMult *= f` dupliqué dans les deux moteurs (le plafond restait appliqué à la résolution ;
// il le reste, par ceinture-bretelles).
export function stackNextMult(current: number, factor: number): number {
  const c = Number.isFinite(current) && current > 0 ? current : 1;
  const f = Number.isFinite(factor) && factor > 0 ? factor : 1;
  return Math.min(NEXT_MULT_CAP, Math.max(0.1, c + (f - 1)));
}
